export default "__VITE_ASSET__Cf65dseS__"